<footer class="footer">
  <div class="container">
    <div class="footer-box">
      <div class="footer-info">
        <span> © Copyright {{ year }}</span>
        <a
          class="footer-info__link"
          href="https://www.camplify.com.au/"
          target="_blank">
          Camplify.
        </a>
        <br />
        All Rights Reserved. ABN 86 603 217 287.
      </div>
    </div>
  </div>
</footer>
